import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { useMerchandisingProperties } from 'app/shared/utils/useMerchandisingProperties';
import { Event } from 'app/shared/typings';
import { Icon } from 'app/shared/components/atoms';
import { Box, Typography } from 'app/shared/components/atoms';
import { ReactComponent as ArrowRight } from 'icons/arrow-right.svg';

interface MerchandisingPropertiesProps {
  event?: Event;
}

export const MerchandisingProperties: React.FC<
  React.PropsWithChildren<MerchandisingPropertiesProps>
> = ({ event }) => {
  const { colors } = useCurrentTheme();
  const properties = useMerchandisingProperties({ event });

  if (!properties || properties.length === 0) {
    return null;
  }

  const displayProperties = () => {
    return properties.map((property: any) => {
      if (!property) {
        return null;
      }
      return (
        <Box
          mb={5}
          w="100%"
          gap={4}
          key={property?.name}
          data-qaid={`merchandising-property-${property.key}`}
        >
          <Icon
            strokeColor={colors.primary.white.base}
            fillColor="none"
            size="lg"
            icon={ArrowRight}
            alignItems="start"
          />
          <Typography fontSize="fontSize100" color={colors.primary.white.base}>
            {property?.name}
          </Typography>
        </Box>
      );
    });
  };

  return (
    <Box pt={4} pb={5}>
      {displayProperties()}
    </Box>
  );
};
